<template>
  <div class="detial_box">
    <a-drawer
      title="法律法规详情"
      placement="right"
      :visible="visible"
      @close="onClose"
      :width="width"
      closable
      destroyOnClose
    >

      <div class="tree_flex" :style="{ right:`${left + 770}px` }" v-if="show && !isModal">
        <div style="border-bottom: 1px solid #f0f0f0;padding:10px 16px;">目录</div>
        <div style="min-width: 300px;max-height: 600px;overflow-y: auto;">
          <a-tree
            show-icon
            :tree-data="treeData"
            :replaceFields="{children:'children', title:'title', key:'chapterCode' }"
            @select="onSelect"
          ></a-tree>
        </div>
      </div>

      <div v-if="isModal">
        <a-modal
            title="目录"
            :visible="show"
            :footer="null"
            @cancel="show = !show"
        >
          <div style="min-width: 300px;max-height: 600px;overflow-y: auto;">
            <a-tree
                show-icon
                :tree-data="treeData"
                :replaceFields="{children:'children', title:'title', key:'chapterCode' }"
                @select="onSelect"
            ></a-tree>
          </div>
        </a-modal>
      </div>

      <div class="header">
        <a-button icon="bars" @click="show = !show">目录</a-button>
        <div style="width: 20px;"></div>
        <a-input-group size="large">
          <a-row :gutter="24">
            <a-col :span="12" style="padding: 0;">
              <a-input v-model="keyword" class="fill" style="border-radius: 4px 0 0 4px;" placeholder="关键字搜索" />
            </a-col>
            <a-col :span="12" style="padding: 0;display: flex;">
              <div class="prev" @click="prev" style="width: 40px;height: 32px;background-color: #f2f4f5;text-align: center;line-height: 32px;"><a-icon type="up" /></div>
              <div class="next" @click="next" style="width: 40px;height: 32px;background-color: #f2f4f5;border-radius: 0 4px 4px 0;text-align: center;line-height: 32px;"><a-icon type="down" /></div>
              <div style="line-height: 32px;margin-left: 5px;" v-if="matches.length">{{ currentIndex + 1 }}/{{ matches.length }}</div>
            </a-col>
          </a-row>
        </a-input-group>
      </div>
      <!-- 描述 -->
      <div style="height: 20px;"></div>
      
      <div ref="content" class="main_content">
        <div>
          <div class="descriptions_title">{{ defaultVal['name'] || '-' }}</div>
          <div style="height: 20px;"></div>
          <a-descriptions bordered :column="2">
            <a-descriptions-item label="公布日期" :span="span">{{ defaultVal['publishTime'] || '-' }}</a-descriptions-item>
            <a-descriptions-item label="实施日期" :span="span">{{ defaultVal['executeTime'] || '-' }}</a-descriptions-item>
            <a-descriptions-item label="时效性" :span="span"><dic-status :text="defaultVal['timelinessDic']"></dic-status></a-descriptions-item>
            <a-descriptions-item label="效力位阶" :span="span"><dic-status :text="defaultVal['effectivenessHierarchyDic']"></dic-status></a-descriptions-item>
            <a-descriptions-item label="制定机关" :span="span">{{ defaultVal['makeUnitName'] || '-' }}</a-descriptions-item>
            <a-descriptions-item label="法规类别" :span="span"><dic-status :text="defaultVal['regulationCategoryDic']"></dic-status></a-descriptions-item>
          </a-descriptions>
        </div>
        <div style="height: 20px;"></div>
        <!-- <div class="desc" v-html="defaultVal['content']">
        </div>
        <div style="height: 20px;"></div> -->
        <div class="main_text">
          <div v-html="viewHtml"></div>
        </div>
        <div style="margin-top: 20px;" v-if="defaultVal['annex'] && defaultVal['annex'].length > 0" v-viewer>
          <template>
            <div :key="index" v-for="(item,index) in defaultVal['annex']" style="margin-top: 10px;">
              <div style="width: 60px;">附件{{ index + 1 }}:</div>
              <div style="width: 100%;" v-if="item.name.match(/\.(jpeg|jpg|gif|png|bmp)$/i) != null">
                <img
                  ref="authImg"
                  :src="caseDownloadFile({
                    fileId:item.uid,
                    fileName:item.name,
                  })"
                  style="width: 100%;"
                  alt="附件"
                />
              </div>
              <a :href="caseDownloadFile({
                fileId:item.uid,
                fileName:item.name,
              })" v-else>{{ item.name }}</a>
            </div>
          </template>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { caseDownloadFile } from '@/services/set'
import { structureToView,structureToTree } from '@/utils/jsonUtil' 
import { lawdDtail,lawTree } from "@/services/agent";
import DicStatus from "@/components/dicStatus";
export default {
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    id:{
      type:String,
      default:''
    },
    // 目录定位偏移量
    left:{
      type:Number,
      default:0
    }
  },
  components: {
        DicStatus
    },
  watch:{
    keyword(){
      this.highlightKeyword()
    },
    id(val){
      if(val && this.visible){
        this.show = false
        this.matches = []
        this.treeData = []
        this.keyword = ''
        this.currentTxt = ''
        this.viewHtml = ''
        this.currentIndex = 0
        this.getLawDetail()
      }
    },
    visible(val){
      if(!val){
        this.keyword = ''
        this.show = false
      }else{
        if(window.innerWidth < 720){
          this.width = '100%'
          this.span = 2
        }else{
          this.width = 700
          this.span = 1
        }

        if(window.innerWidth < 1150){
          this.isModal = true
        }else{
          this.isModal = false
        }
      }
    }
  },
  data(){
    return{
      lawId:'',
      matches:[],
      treeData:[],
      show:false,
      keyword:'',
      viewHtml:'',
      currentTxt:'',
      currentIndex:0,
      defaultVal:{},
      isModal:false,
      width: 700,
      span: 1
    }
  },
  mounted() {
    if(window.innerWidth < 1150){
      this.isModal = true
    }else{
      this.isModal = false
    }
  },
  methods:{
    caseDownloadFile,
    async getLawDetail(){
        let res = await lawdDtail(this.id)
        if(res.code == 200){
            this.defaultVal = res.data
            this.lawId = res.data.id
            this.getLawTree()
        }
    },
    async getLawTree(){
        let res = await lawTree({
            lawBookId:this.lawId
        })
        if(res.code == 200 && res.data.length){
            this.treeData = structureToTree(res.data)
            this.viewHtml = this.defaultVal.content + structureToView(res.data)
            this.currentTxt = this.defaultVal.content + structureToView(res.data)
        }
    },
    prev(){
      if (this.matches.length === 0) return;
      if(this.currentIndex == 0){
        this.currentIndex = this.matches.length - 1
      }else{
        this.currentIndex = this.currentIndex - 1;
      }
      this.scrollToMatch();
    },
    next(){
      if (this.matches.length === 0) return;
      if((this.currentIndex + 1) == this.matches.length){
        this.currentIndex = 0
      }else{
        this.currentIndex = (this.currentIndex + 1);
      }
      this.scrollToMatch();
    },
    onSelect(val){
      if(val.length == 0) return
      const ele = document.getElementById(`div${val}`);
      ele.scrollIntoView({
        behavior: 'smooth'
      })
      if(this.isModal){
        this.show = !this.show
      }
    },
    onClose(){
      this.$emit('update:visible',false)
    },
    highlightKeyword() {
      if (this.keyword === "") {
        this.viewHtml = this.currentTxt;
        this.matches = [];
        return;
      }

      // 创建正则表达式，匹配关键词，忽略大小写和全局搜索
      const regex = new RegExp(`(${this.keyword})`, "gi");

      // 创建一个函数来处理替换操作
      const replaceFunction = (match, p1) => {
        return `<span class="highlight">${p1}</span>`;
      };

      // 创建一个函数来处理文本中的关键词替换，同时跳过HTML标签
      const processText = (text) => {
        // 匹配HTML标签
        const tagRegex = /<[^>]*>/g;
        let lastIndex = 0;
        let result = '';

        // 分割文本，保留HTML标签
        text.replace(tagRegex, (tagMatch, offset) => {
          // 处理非标签部分
          const nonTagPart = text.slice(lastIndex, offset);
          if (nonTagPart) {
            result += nonTagPart.replace(regex, replaceFunction);
          }

          // 添加标签
          result += tagMatch;
          lastIndex = offset + tagMatch.length;
          return ''; // 返回空字符串是因为我们已经处理了这个标签
        });

        // 处理最后一个非标签部分
        if (lastIndex < text.length) {
          result += text.slice(lastIndex).replace(regex, replaceFunction);
        }

        return result;
      };

      // 应用处理函数
      this.viewHtml = processText(this.currentTxt);

      this.$nextTick(() => {
        this.matches = this.$refs.content.querySelectorAll(".highlight");
        this.currentIndex = 0;
        this.matches[this.currentIndex].classList.add("current");
        this.matches[0].scrollIntoView({ behavior: 'smooth' });
      });
    },
    scrollToMatch() {
      if (this.currentIndex >= 0 && this.currentIndex < this.matches.length) {
        const match = this.matches[this.currentIndex];
        // 移除所有匹配项的current类
        this.matches.forEach(item => item.classList.remove("current"));
        // 给当前匹配项添加current类
        match.classList.add("current");
        // const container = this.$refs.content;
        // const matchRect = match.getBoundingClientRect();
        match.scrollIntoView({
          behavior: 'smooth'
        })
        // if(this.currentIndex == 0){
        //   container.scrollTop = 0
        // }
        // container.scrollTop = container.scrollTop + 200 +matchRect.top - container.clientHeight;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-drawer-body{
  padding-right: 0;
  overflow: hidden;
}
.main_content{
  height: calc(100vh - 160px);
  overflow-y: auto;
  padding-right: 10px;
}
::v-deep .current{
    background-color: $base_color;
    color: #fff !important;
}
::v-deep .highlight{
    color: $base_color;
}
::v-deep .ant-input{
  height: 32px !important;
  padding: 3px 11px;
  font-size: 14px;
}
::v-deep .bian{
    font-size:14px; 
    line-height:240%;
    text-align: center;
    font-weight:bold;
}
::v-deep .tiao .title{
    font-weight:bold;
}
::v-deep .zhang{
    font-size:14px;
    line-height:240%;
    text-align: center;
    font-weight:bold;
}
::v-deep .jie{
    text-align: center;
    font-size:14px;
    line-height:190%;
    word-wrap:break-word;
    word-break:break-all;
    font-weight:bold;
}
::v-deep .tiao{
    text-indent:2em;
    display:inline-block;
    vertical-align:baseline;
    font-size:14px;
    line-height:190%;
    word-wrap:break-word;
    word-break:break-all;
}
.descriptions_title{
  text-align: center;
  font-size: 16px;
  font-weight: 800;
}
.header{
  display: flex;
}
.tree_flex{
  top: 50px;
  position: fixed;
  z-index: 99999999999999;
  width: 400px;
  background-color: #fff;
  ::v-deep .ant-tree-node-content-wrapper{
    width: 300px !important;
    height: auto !important;
  }
  ::v-deep .ant-tree-title{
    display: inline-block;
    width: 300px !important;
    white-space: pre-wrap;
    word-break: break-all;
    height: auto !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.prev{
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.next{
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
</style>